import React, { useState, useEffect } from 'react';
import Storage from '@aws-amplify/storage';

const S3DownloadLink = ({
  s3_key,
  children,
  className = 'text-jcap-600',
  ...linkProps
}) => {
  const [href, setHref] = useState('');

  useEffect(() => {
    if (s3_key) {
      Storage.get(s3_key)
        .then((url) => {
          setHref(url.toString());
        })
        .catch((err) => console.warn(err));
    }
  }, [s3_key]);

  return (
    <a
      className={className}
      {...linkProps}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};

export default S3DownloadLink;
